/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ContactEmailsQueryVariables = {
    slug: string;
};
export type ContactEmailsQueryResponse = {
    readonly contactShow: {
        readonly emails: {
            readonly " $fragmentRefs": FragmentRefs<"EmailsTab_emails">;
        };
    };
};
export type ContactEmailsQuery = {
    readonly response: ContactEmailsQueryResponse;
    readonly variables: ContactEmailsQueryVariables;
};



/*
query ContactEmailsQuery(
  $slug: String!
) {
  contactShow(slug: $slug) {
    emails {
      ...EmailsTab_emails
    }
    id
  }
}

fragment Attachment_attachment on Attachment {
  url
  name
  contentType
  previewUrl
}

fragment EmailItem_email on Email {
  slug
  subject
  from
  to
  body
  sentAt
  attachments {
    name
    ...SmallAttachment_attachment
    ...Attachment_attachment
  }
}

fragment EmailsCard_emails on EmailConnection {
  nodes {
    slug
    ...EmailItem_email
    id
  }
}

fragment EmailsTab_emails on EmailConnection {
  ...EmailsCard_emails
}

fragment SmallAttachment_attachment on Attachment {
  url
  name
  contentType
  previewUrl
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContactEmailsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Contact",
        "kind": "LinkedField",
        "name": "contactShow",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EmailConnection",
            "kind": "LinkedField",
            "name": "emails",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EmailsTab_emails"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContactEmailsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Contact",
        "kind": "LinkedField",
        "name": "contactShow",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EmailConnection",
            "kind": "LinkedField",
            "name": "emails",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Email",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subject",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "from",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "to",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "body",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sentAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Attachment",
                    "kind": "LinkedField",
                    "name": "attachments",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "contentType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "previewUrl",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "29185c1fe678baa18eb9319f3a8ffba6",
    "id": null,
    "metadata": {},
    "name": "ContactEmailsQuery",
    "operationKind": "query",
    "text": "query ContactEmailsQuery(\n  $slug: String!\n) {\n  contactShow(slug: $slug) {\n    emails {\n      ...EmailsTab_emails\n    }\n    id\n  }\n}\n\nfragment Attachment_attachment on Attachment {\n  url\n  name\n  contentType\n  previewUrl\n}\n\nfragment EmailItem_email on Email {\n  slug\n  subject\n  from\n  to\n  body\n  sentAt\n  attachments {\n    name\n    ...SmallAttachment_attachment\n    ...Attachment_attachment\n  }\n}\n\nfragment EmailsCard_emails on EmailConnection {\n  nodes {\n    slug\n    ...EmailItem_email\n    id\n  }\n}\n\nfragment EmailsTab_emails on EmailConnection {\n  ...EmailsCard_emails\n}\n\nfragment SmallAttachment_attachment on Attachment {\n  url\n  name\n  contentType\n  previewUrl\n}\n"
  }
};
})();
(node as any).hash = 'c1c192e771e17cd5e2e6954772554592';
export default node;
